var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._g({staticClass:"anticon"},_vm.$listeners),[_c('font-awesome-icon',_vm._b({attrs:{"border":_vm.border,"fixed-width":_vm.fixedWidth,"flip":_vm.flip,"icon":[_vm.type, _vm.name],"pulse":_vm.pulse,"rotation":_vm.rotate,"size":_vm.size,"spin":_vm.spin,"transform":_vm.transform}},'font-awesome-icon',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }